import { Component, OnInit } from '@angular/core';
import { CdkDragStart } from '@angular/cdk/drag-drop';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  backBtnDragging: any;
  tab1: boolean;
  tab2: boolean;
  tab3: boolean;
  tabList: any[] = [
    {
      id: 'tab1'
    },
    {
      id: 'tab2'
    },
    {
      id: 'tab3'
    }
  ];
  fistDataArr: any[] = [
    {
      ques: 'lang.appShared.faqComponent.toAssessAnyOpportunity',
      ans: 'lang.appShared.faqComponent.ourBaseApproachIsGuided'
    },
    {
      ques: 'lang.appShared.faqComponent.platformHosted',
      ans: 'lang.appShared.faqComponent.emeaVersionOfPlatform'
    },
    {
      ques: 'lang.appShared.faqComponent.canThePlatformBeHosted',
      ans: 'lang.appShared.faqComponent.architecturallyThePlatform'
    },
    {
      ques: 'lang.appShared.faqComponent.customersUsingThePlatform',
      ans: 'lang.appShared.faqComponent.customersName'
    },
    {
      ques: 'lang.appShared.faqComponent.operationalTechnologies',
      ans: 'lang.appShared.faqComponent.ourCurrentFocus'
    },
    {
      ques: 'lang.appShared.faqComponent.hopeProcessMining',
      ans: 'lang.appShared.faqComponent.processMiningDiscovery'
    },
    {
      ques: 'lang.appShared.faqComponent.strategyToMarket',
      ans: 'lang.appShared.faqComponent.theDetailedArticulation'
    },
    {
      ques: 'lang.appShared.faqComponent.doesItHaveTheCapability',
      ans: 'lang.appShared.faqComponent.capabilityWithinThePlatform'
    },
    {
      ques: 'lang.appShared.faqComponent.dataAnalyticsDashboard',
      ans: 'lang.appShared.faqComponent.mostOperationalDataAnalytics'
    },
    {
      ques: 'lang.appShared.faqComponent.apartFromPredictiveManagement',
      ans: 'lang.appShared.faqComponent.yesThisCan'
    },
    {
      ques: 'lang.appShared.faqComponent.isThereSharedComponents',
      ans: 'lang.appShared.faqComponent.uiPathOrchestrator'
    },
    {
      ques: 'lang.appShared.faqComponent.whoOwnsTheLicenses',
      ans: 'lang.appShared.faqComponent.capgeminiOwnsTheTools'
    },
    {
      ques: 'lang.appShared.faqComponent.willCustomersSharing',
      ans: 'lang.appShared.faqComponent.customersWillBeSharing'
    },
    {
      ques: 'lang.appShared.faqComponent.howIsThisPlatform',
      ans: 'lang.appShared.faqComponent.ciapHasBeenBuilt'
    },
    {
      ques: 'lang.appShared.faqComponent.trainingClassroom',
      ans: 'lang.appShared.faqComponent.groupIndustrialization'
    },
    {
      ques: 'lang.appShared.faqComponent.whatIsYourPlan',
      ans: 'lang.appShared.faqComponent.thePlatformHasTheCapability'
    },
    {
      ques: 'lang.appShared.faqComponent.doYouHaveDR',
      ans: 'lang.appShared.faqComponent.thePlatformArchitecture'
    },
    {
      ques: 'lang.appShared.faqComponent.howTheClientData',
      ans: 'lang.appShared.faqComponent.theDataSecurity'
    }
  ];

  secondDataArr: any[] = [
    {
      ques: 'lang.appShared.faqComponent.customerProvidingApproval',
      ans: ['lang.appShared.faqComponent.weCanExtractData', 'lang.appShared.faqComponent.frequencyOfProviding']
    },
    {
      ques: 'lang.appShared.faqComponent.accessibilityToAllData',
      ans: ['lang.appShared.faqComponent.weAreManagingAudit', 'lang.appShared.faqComponent.ifWeGetAccess']
    }
  ];
  thridDataArr: any[] = [
    {
      ques: 'lang.appShared.faqComponent.customerProvidingAccess',
      ans: ['lang.appShared.faqComponent.configureAPMToSend', 'lang.appShared.faqComponent.inCaseAPMSystem']
    },
    {
      ques: 'lang.appShared.faqComponent.monitoringTool',
      ans: ['lang.appShared.faqComponent.directlyThrough', 'lang.appShared.faqComponent.significantImpact']
    },
    {
      ques: 'lang.appShared.faqComponent.costEffectiveness',
      ans: ['lang.appShared.faqComponent.anOptionWasToManage', 'lang.appShared.faqComponent.alsoGivenThatOurApproach']
    },
    {
      ques: 'lang.appShared.faqComponent.customerWillingness',
      ans: [
        'lang.appShared.faqComponent.thisAccessIsTypically',
        'lang.appShared.faqComponent.thisIsAStandard',
        'lang.appShared.faqComponent.cARBProcess',
        'lang.appShared.faqComponent.asWeMoveForward'
      ]
    },
    {
      ques: 'lang.appShared.faqComponent.roiOrCostEffectiveness',
      ans: ['lang.appShared.faqComponent.currentCosting']
    },
    {
      ques: 'lang.appShared.faqComponent.engagementsUsingNonUipath',
      ans: ['lang.appShared.faqComponent.integrateTheTools']
    },
    {
      ques: 'lang.appShared.faqComponent.lackOfStrong',
      ans: ['lang.appShared.faqComponent.ayehuIsNotDefault']
    },
    {
      ques: 'lang.appShared.faqComponent.forCertainEngagements',
      ans: ['lang.appShared.faqComponent.weAreLooking']
    },
    {
      ques: 'lang.appShared.faqComponent.newLocationIsLive',
      ans: ['lang.appShared.faqComponent.frankfurtByMidApril']
    },
    {
      ques: 'lang.appShared.faqComponent.easeOfSetupAndAccess',
      ans: ['lang.appShared.faqComponent.theSetupWillRequire']
    },
    {
      ques: 'lang.appShared.faqComponent.mostOfTheLargeEngagements',
      ans: [
        'lang.appShared.faqComponent.addressedOnACase',
        'lang.appShared.faqComponent.currentEngagements',
        'lang.appShared.faqComponent.solutionComponents',
        'lang.appShared.faqComponent.strongSecurityFocus',
        'lang.appShared.faqComponent.maintenanceOfTheseDiverse'
      ]
    },
    {
      ques: 'lang.appShared.faqComponent.weCollectIndustrialization',
      ans: ['lang.appShared.faqComponent.aPossibleModelForDeployment']
    },
    {
      ques: 'lang.appShared.faqComponent.dashboardIntegration',
      ans: ['lang.appShared.faqComponent.europeTeamOnAll']
    }
  ];
  technicalFaq: any[] = [
    {
      ques: 'lang.appShared.faqComponent.whichEncryptionServices',
      ans: 'lang.appShared.faqComponent.awsKmsServices'
    },
    {
      ques: 'lang.appShared.faqComponent.whichServicesAreProvisioned',
      ans: 'lang.appShared.faqComponent.awsCloudTrailIsLeveraged'
    },
    {
      ques: 'lang.appShared.faqComponent.whichEncryptionServices',
      ans: 'lang.appShared.faqComponent.awsKmsServices'
    },
    {
      ques: 'lang.appShared.faqComponent.customersExistingAD',
      ans: 'lang.appShared.faqComponent.yesWeCanLeverage'
    },
    {
      ques: 'lang.appShared.faqComponent.doCIAPSupportMulti',
      ans: 'lang.appShared.faqComponent.applicationToApplication'
    },
    {
      ques: 'lang.appShared.faqComponent.areTheApplications',
      ans: 'lang.appShared.faqComponent.yesAllTheApplications'
    }
  ];
  selectedTab: any;

  constructor(private router: Router, private _location: Location) {}

  ngOnInit() {
    this.selectedTab = this.tabList[0];
  }

  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  toggleTab(selectedOption: string) {
    this.gotoTop();
    this.selectedTab = this.tabList.find(i => i.id === selectedOption);
  }

  navigateBack() {
    if (this.backBtnDragging) {
      this.backBtnDragging = false;
      return;
    }

    this._location.back();
  }

  handleDragStart(draggingEle: string, $event: CdkDragStart) {
    if (draggingEle === 'back-button') {
      this.backBtnDragging = true;
    }
  }
}
